const AG_GRID_LOCALE_DE = {
    // Set Filter
    selectAll: '(Wählen Sie Alle)',
    selectAllSearchResults: '(Alle auswählen Suchergebnisse)',
    searchOoo: 'Suche...',
    blanks: '(Leer)',
    noMatches: 'Keine Treffer',

    //
    views: 'Ansichten',

    // Number Filter & Text Filter
    filterOoo: 'Filter...',
    equals: 'Gleich',
    notEqual: 'Nicht gleich',
    empty: 'Wähle ein',

    // Number Filter
    lessThan: 'Weniger als',
    greaterThan: 'Größer als',
    lessThanOrEqual: 'Weniger als oder gleich',
    greaterThanOrEqual: 'Größer als oder gleich',
    inRange: 'Im Bereich',
    inRangeStart: 'bis',
    inRangeEnd: 'von',

    // Text Filter
    contains: 'Enthält',
    notContains: 'Nicht enthält',
    startsWith: 'Beginnt mit',
    endsWith: 'Endet mit',

    // Date Filter
    dateFormatOoo: 'dd.mm.yyyy',

    // Filter Conditions
    andCondition: 'UND',
    orCondition: 'ODER',

    // Filter Buttons
    applyFilter: 'Anwenden',
    resetFilter: 'Reset',
    clearFilter: 'Klar',
    cancelFilter: 'Stornieren',

    // Filter Titles
    textFilter: 'Text filter',
    numberFilter: 'Anzahl Filter',
    dateFilter: 'Datum Filter',
    setFilter: 'Set Filter',

    // Side Bar
    columns: 'Spalten',
    filters: 'Filter',

    // columns tool panel
    pivotMode: 'Pivot-Modus',
    groups: 'Zeilengruppen',
    rowGroupColumnsEmptyMessage: 'Ziehen Sie hier, um die eingestellte Zeilengruppen',
    values: 'Werte',
    valueColumnsEmptyMessage: 'Ziehen Sie hier, um die Gesamt',
    pivots: 'Spalte Labels',
    pivotColumnsEmptyMessage: 'Ziehen Sie hier, um die eingestellte Spaltenbeschriftungen',

    // Header of the Default Group Column
    group: 'Gruppe',

    // Other
    loadingOoo: 'Wird geladen...',
    noRowsToShow: 'Keine Zeilen anzeigen',
    enabled: 'Aktiviert',

    // Menu
    pinColumn: 'Pin Spalte',
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'Kein Pin',
    valueAggregation: 'Wert Aggregation',
    autosizeThiscolumn: 'Autosize dieser Spalte',
    autosizeAllColumns: 'Automatisch anpassen Alle Spalten',
    groupBy: 'Gruppiere nach',
    ungroupBy: 'Un-Gruppe von',
    resetColumns: 'Reset Spalten',
    expandAll: 'Alle erweitern',
    collapseAll: 'Alle schließen',
    copy: 'Kopieren',
    ctrlC: 'Strg + C',
    copyWithHeaders: 'Kopieren Mit Headers',
    paste: 'EINFÜGEN',
    ctrlV: 'Strg + V',
    export: 'Export',
    csvExport: 'CSV-Export',
    excelExport: 'Excel Export (.xlsx)',
    excelXmlExport: 'Excel Export (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Summe',
    min: 'Mindest',
    max: 'Max',
    none: 'Keiner',
    count: 'Anzahl',
    avg: 'Durchschnittlich',
    filteredRows: 'Gefiltert',
    selectedRows: 'Ausgewählt',
    totalRows: 'Insgesamt Reihen',
    totalAndFilteredRows: 'Reihen',
    more: 'Mehr',
    to: 'zu',
    of: 'von',
    page: 'Seite',
    nextPage: 'Nächste Seite',
    lastPage: 'Letzte Seite',
    firstPage: 'Erste Seite',
    previousPage: 'Vorherige Seite',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Pivot-Diagramm',
    rangeChartTitle: 'Range Sortimentsübersicht',
    settings: 'Die Einstellungen',
    data: 'Daten',
    format: 'Format',
    categories: 'Kategorien',
    defaultCategory: '(None(Keiner)',
    series: 'Serie',
    xyValues: 'X Y',
    paired: 'Paired Gekoppelte Mode',
    axis: 'Achse',
    navigator: 'Navigator',
    color: 'Farbe',
    thickness: 'Dicke',
    xType: 'X Type',
    automatic: 'Automatisch',
    category: 'Kategorie',
    number: 'Nummer',
    time: 'Zeit',
    xRotation: 'X X Rotation',
    yRotation: 'Y Y Rotation',
    ticks: 'Ticks',
    width: 'Breite',
    height: 'Höhe',
    length: 'Länge',
    padding: 'Polsterung',
    spacing: 'Abstand',
    chart: 'Diagramm',
    title: 'Titel',
    titlePlaceholder: 'titel - Doppelklick auf bearbeiten',
    background: 'Hintergrund',
    font: 'Schriftart',
    top: 'Oben',
    right: 'Recht',
    bottom: 'Unterseite',
    left: 'Links',
    labels: 'Labels',
    size: 'Größe',
    minSize: 'Minimum Mindestmaß',
    maxSize: 'Maximum Maximale Größe',
    legend: 'Legende',
    position: 'Position',
    markerSize: 'Marker Marker Size',
    markerStroke: 'Marker Marker Stroke',
    markerPadding: 'Marker Marker Padding',
    itemSpacing: 'Item Artikel Spacing',
    itemPaddingX: 'Item Padding Artikel Padding X',
    itemPaddingY: 'Item Padding Artikel Padding Y',
    layoutHorizontalSpacing: 'Horizontal Horizontaler Abstand',
    layoutVerticalSpacing: 'Vertical Vertikaler Abstand',
    strokeWidth: 'Stroke Strichbreite',
    offset: 'Offset',
    offsets: 'Versetzt',
    tooltips: 'Tooltips',
    callout: 'Aufbieten, ausrufen, zurufen',
    markers: 'Marker',
    shadow: 'Schatten',
    blur: 'Verwischen',
    xOffset: 'X X Offset',
    yOffset: 'Y Y Offset',
    lineWidth: 'Line Linienbreite',
    normal: 'Normal',
    bold: 'Fett gedruckt',
    italic: 'Kursiv',
    boldItalic: 'Bold Fett Kursiv',
    predefined: 'Vordefinierte',
    fillOpacity: 'Fill Fülldeckkraft',
    strokeOpacity: 'Line Linie Opazität',
    histogramBinCount: 'Bin Bin count',
    columnGroup: 'Säule',
    barGroup: 'Bar',
    pieGroup: 'Kuchen',
    lineGroup: 'Linie',
    scatterGroup: 'X Y (ScatterX Y (Scatter)',
    areaGroup: 'Bereich',
    histogramGroup: 'Histogramm',
    groupedColumnTooltip: 'Gruppierte',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% 100% Stacked',
    groupedBarTooltip: 'Gruppierte',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% 100% Stacked',
    pieTooltip: 'Kuchen',
    doughnutTooltip: 'Krapfen',
    lineTooltip: 'Linie',
    groupedAreaTooltip: 'Bereich',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% 100% Stacked',
    scatterTooltip: 'Streuen',
    bubbleTooltip: 'Blase',
    histogramTooltip: 'Histogramm',
    noDataToChart: 'Keine Daten verfügbar zu kartiert werden. ',
    pivotChartRequiresPivotMode: 'Pivot-Diagramm erfordert Pivot-Modus aktiviert. ',
};

export default AG_GRID_LOCALE_DE;
